import React, { useState } from "react";
import { resolveAsset } from "@/components/kit/FileUpload";
import { cn } from "@/lib/utils";

// Product image inherited by an offer/card; falls back to initials of the product name.
export function OfferThumb({ image, name, size = "md" }) {
  const cls = size === "lg" ? "h-14 w-14 text-base" : size === "sm" ? "h-8 w-8 text-[10px]" : "h-10 w-10 text-xs";
  const src = resolveAsset(image);
  const initials = (name || "?").trim().slice(0, 2).toUpperCase();
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={cn("relative flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white/[0.06] font-semibold text-muted-foreground", cls)}>
      {src ? (
        <>
          {!loaded && <div className="absolute inset-0 animate-pulse bg-white/[0.06]" />}
          <img src={src} alt="" loading="lazy" decoding="async" onLoad={() => setLoaded(true)}
            className={cn("h-full w-full object-cover transition-opacity duration-200", loaded ? "opacity-100" : "opacity-0")} />
        </>
      ) : initials}
    </div>
  );
}
